<template>
    <div id="About">

        <div class="cv-rounded mb-5">
            <div class="w-100 d-md-none">
                <!-- <img src="https://placehold.co/600x350/00B04E/ffffff?text=Acerca+de+Clave+Verde" alt="Placeholder" class="img-fluid w-100"> -->
                <img src="@/assets/banners-clave-verde/optmized/BannerAcercaDe600x350.jpg" alt="Acerca de Clave Verde" class="img-fluid w-100" />
            </div>
    
            <div class="w-100 d-none d-md-block d-lg-none">
                <img src="@/assets/banners-clave-verde/optmized/BannerAcercaDe700x250.jpg" alt="Acerca de Clave Verde" class="img-fluid w-100">
            </div>
    
            <div class="w-100 d-none d-lg-block">
                <img src="@/assets/banners-clave-verde/optmized/BannerAcercaDe1920x300px.jpg" alt="Acerca de Clave Verde" class="img-fluid w-100">
            </div>
        </div>

        <div class="p-5">
    
            <div class="text-center">
                <h1>Acerca de Clave Verde</h1>
            </div>
    
            <hr>
    
            <div class="limit-width mt-4">
                <p>
                    Clave Verde es un programa del Gobierno del Estado de San Luis Potosí que proporciona 
                    acceso gratuito a internet para los ciudadanos potosinos.
                </p>
                <p>
                    A través de Clave Verde, el gobierno ha establecido una infraestructura de conectividad 
                    que permite a los usuarios acceder a servicios digitales esenciales sin costo.
                </p>
                <p>
                    <strong>Blackfon</strong> (Blackfon.mx) actúa como proveedor de servicios dentro de este 
                    programa, facilitando el acceso a la red de internet gratuito de Clave Verde y brindando 
                    soluciones de conectividad a los beneficiarios del programa.
                </p>
                <p>
                    Esta plataforma permite a los usuarios gestionar su acceso a Clave Verde de manera 
                    sencilla y eficiente, aprovechando la infraestructura proporcionada por el gobierno 
                    estatal a través de nuestros servicios.
                </p>
            </div>
        </div>


    </div>
</template>

<script>
export default {
    name: 'About',
};
</script>
